import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './IntersectionInfo.module.css';
import Spinner from "../ui/Spinner";

export const IntersectionInfo = (props) => {
    const { intersection } = props;
    const { t } = useTranslation();
    if (!intersection) return <Spinner />;

    const propertyNames = [
        { propName: 'id',                       title: t('info.id'),                        description: t('info.desc.id') },
        { propName: 'liva_nro',                 title: t('info.liva_nro'),                  description: t('info.desc.liva_nro') },
        { propName: 'paikka',                   title: t('info.paikka'),                    description: t('info.desc.paikka') },
        { propName: 'yhteinen_koje',            title: t('info.yhteinen_koje'),             description: t('info.desc.yhteinen_koje') },
        { propName: 'liittymä_rakennettu',      title: t('info.liittymä_rakennettu'),       description: t('info.desc.liittymä_rakennettu') },
        { propName: 'kojetyyppi',               title: t('info.kojetyyppi'),                description: t('info.desc.kojetyyppi') },
        { propName: 'koje_vuodelta',            title: t('info.koje_vuodelta'),             description: t('info.desc.koje_vuodelta') },
        { propName: 'tila_kaytossa',            title: t('info.tila_kaytossa'),             description: t('info.desc.tila_kaytossa') },
        { propName: 'paivystysluokka',          title: t('info.paivystysluokka'),           description: t('info.desc.paivystysluokka') },
        { propName: 'yoajantoiminta',           title: t('info.yoajantoiminta'),            description: t('info.desc.yoajantoiminta') },
        { propName: 'imflow_liittyma',          title: t('info.imflow_liittyma'),           description: t('info.desc.imflow_liittyma') },
        { propName: 'rv_valo',                  title: t('info.rv_valo'),                   description: t('info.desc.rv_valo') },
        { propName: 'tunnelin_varareitti',      title: t('info.tunnelin_varareitti'),       description: t('info.desc.tunnelin_varareitti') },
        { propName: 'aaniopastettu_liittyma',   title: t('info.aaniopastettu_liittyma'),    description: t('info.desc.aaniopastettu_liittyma') },
        { propName: 'joukkoliikenne_etuus',     title: t('info.joukkoliikenne_etuus'),      description: t('info.desc.joukkoliikenne_etuus') },
        { propName: 'halytysajoneuvojen_etuus', title: t('info.halytysajoneuvojen_etuus'),  description: t('info.desc.halytysajoneuvojen_etuus') },
        { propName: 'raskaanliikenteen_etuus',  title: t('info.raskaanliikenteen_etuus'),   description: t('info.desc.raskaanliikenteen_etuus') },
        { propName: 'crosscycle_liittyma',      title: t('info.crosscycle_liittyma'),       description: t('info.desc.crosscycle_liittyma') },
        { propName: 'glosa',                    title: t('info.glosa'),                     description: t('info.desc.glosa') },
        { propName: 'kvt_verkko',               title: t('info.kvt_verkko'),                description: t('info.desc.kvt_verkko') },
        { propName: 'omistus',                  title: t('info.omistus'),                   description: t('info.desc.omistus') },
        { propName: 'kunta',                    title: t('info.kunta'),                     description: t('info.desc.kunta') }
    ];

    const knownPropNames = propertyNames.map(p => p.propName);
    const missingPropNames = Object.keys(intersection).filter(k => !knownPropNames.includes(k));

    return (
        <div className={classes.StatConteiner} key={'info'}>
            {propertyNames.map(entry => {
                return <div className={classes.StatRow} key={entry.propName}>
                    <div className={classes.StatTitle} title={entry.description}>{entry.title}</div>
                    <div className={classes.StatValue}>{intersection[entry.propName]}</div>
                </div>
            })}
            {missingPropNames.map(key => {
                console.log('unknown intersection property: ' + key);
                return <div className={classes.StatRow} key={key}>
                    <div className={classes.StatTitle} title={t('info.unknown')}>{key}</div>
                    <div className={classes.StatValue}>{intersection[key]}</div>
                </div>
            })}
        </div>
    );
};
